import type { ColumnPrediction } from '@features/regional-overview/digital-traps/domain/flight-prediction.models';
import type { TimelineSegment } from './flight-stage-timeline.model';

/**
 * Collapse the per-column predictions into grid placements. Each defined column
 * becomes a segment anchored at its index, spanning its colSpan (clamped so it can
 * never overflow the available columns). Empty columns are left for the grid to fill.
 */
export const buildSegments = (columnPredictions: (ColumnPrediction | undefined)[]): TimelineSegment[] =>
  columnPredictions.reduce<TimelineSegment[]>((segments, columnPrediction, index) => {
    if (columnPrediction) {
      const span = Math.min(Math.max(1, columnPrediction.colSpan), columnPredictions.length - index);
      segments.push({ prediction: columnPrediction.prediction, start: index, span });
    }
    return segments;
  }, []);
